import { useCallback } from 'react';

import { ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { extendedDosageTemplatesTranslationKeys } from '../../../../../translations';
import { DosageTemplates } from '../DosageTemplates';
import { DosageInitialEditTemplate, DosageTemplateUse } from '../DosageTemplates.types';
import { DosageTemplatesSendTemplateButton } from '../DosageTemplatesSendTemplateButton';
import { DosageTemplatesUseTemplateModalConfirmButton } from '../DosageTemplatesUseTemplateModalConfirmButton';

type DosageTemplatesModalProps = {
   readonly onClose: VoidFunction;
   readonly onUse: DosageTemplateUse;
   readonly shouldConfirmUse: boolean;
   readonly initialEditTemplate: DosageInitialEditTemplate;
};

export const DosageTemplatesModal = (props: DosageTemplatesModalProps): JSX.Element => {
   const handleUseTemplate: DosageTemplateUse = useCallback(
      (template) => {
         props.onUse(template);
         props.onClose();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onUse, props.onClose]
   );

   return (
      <FormsTemplates.Modal
         testId={'dosageTemplates'}
         title={extendedDosageTemplatesTranslationKeys.extendedDosageTemplates}
         width={ModalWidth.FULL_MINIMAL_SCREEN}
      >
         <DosageTemplates
            initialEditTemplate={props.initialEditTemplate}
            editSlot={({ handleSubmit, ready, onTemplateSaveSuccess, formState, saveBlocked }) => (
               <>
                  <DosageTemplatesSendTemplateButton
                     handleSubmit={handleSubmit}
                     onSuccess={onTemplateSaveSuccess}
                     disabled={ready || saveBlocked}
                  />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
            readOnlySlot={
               <DosageTemplatesUseTemplateModalConfirmButton
                  shouldConfirm={props.shouldConfirmUse}
                  onClick={handleUseTemplate}
               />
            }
         >
            <FormsTemplates.ExitModalButtons onCancel={props.onClose} />
         </DosageTemplates>
      </FormsTemplates.Modal>
   );
};
